// UnitTab.js
import {
  Grid,
  Typography,
  Box,
  Button,
  InputAdornment
} from "@mui/material";
import { DataGridPro } from '@mui/x-data-grid-pro';
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { toast, ToastContainer } from "react-toastify";
import UnitDialog from "screens/Inventory/component/UnitofMeasurement";
import { useUnitLogic } from "../logic/UnitofMeasureTabLogic";
import TextField from '@mui/material/TextField'


const UnitTab = () => {
  
  const { UnitProps } = useUnitLogic(toast);
  const {
    handleOpenUnitDlg,
    columns,
    paginationModel,
    setPaginationModel,
    openUnitDlg,
    handleCloseUnitDlg,
    rows,
    handleSearch,
    searchText,
    loading
  } = UnitProps;
  //#endregion

  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", lg: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", lg: "center" },
              gap: { xs: 2, lg: 0 },
            }}
          >
            {/* LEFT SIDE: Title + Subtitle */}
            <Box>
              <Typography variant="h3">Units of Measure</Typography>
              <Typography color="secondary">
                Manage your desired Units of Measure in the system.
              </Typography>
            </Box>

            {/* RIGHT SIDE: Search + Create Button */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                alignItems: { xs: "stretch", sm: "center" },
              }}
            >
              <TextField
                placeholder="Search Units"
                size="small"
                value={UnitProps.searchText}
                onChange={(e) => UnitProps.handleSearch(e.target.value)}
                sx={{
                  width: { xs: "100%", sm: 300 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                variant="contained"
                color="main"
                startIcon={<AddIcon />}
                onClick={handleOpenUnitDlg}
              >
                Create Unit
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <DataGridPro
            // pagination
            rows={UnitProps.rows || []}
            rowHeight={62}
            columns={columns || []}
            // pageSizeOptions={[
            //   10,
            //   50,
            //   { value: (rows || []).length, label: "Show All" },
            // ]}
            disableRowSelectionOnClick
            // paginationModel={paginationModel}
            // onPaginationModelChange={setPaginationModel}
            slots={{
              footer: () => null
            }}
            sx={{
              minHeight: 250,
              maxHeight: 500,
              "& .MuiDataGrid-columnHeaderTitle": {
                textTransform: "none",
              },
            }}
          />
        </Grid>
      </Grid>

      {/*<ToastContainer />*/}
      <UnitDialog
        open={openUnitDlg}
        handleClose={handleCloseUnitDlg}
        UnitProps={UnitProps}
      />
    </>
  );
};

export default UnitTab;